module.exports = __webpack_public_path__ + "static/media/1920x600-elYw_Egg-130122.bc09c0b1.jpg";